define('shared/page/wcmmode',['$', 'shared/lib/RSVP'], function ($, RSVP) {
    'use strict';

    return function(){
        var result = $('html').hasClass('wcmmode-disabled') ? 'disabled' : $('html').hasClass('wcmmode-edit') ? 'edit' : 'design';

        return RSVP.resolve(result);
    };
});
